export const generateUID = (maxLength = 15) => {
  const uid = Date.now() + (Math.random() * 10000).toFixed();
  const startIdx = Math.max(uid.length - maxLength, 0);
  return uid.substring(startIdx);
};
